export default "__VITE_ASSET__143f1a98__"